export default {
	meta: {
		title: 'Export',
		description: 'Export'
	}
};
